// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts__1ROPC","email":"Contacts_email__7UGSR"};